const initialState = {
  users: null,
};

export default function gameReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_USERS":
      return {
        ...state,
        users: action.users,
      };
    default:
      return {
        ...state,
      };
  }
}
